import { render } from "./LectureReview.vue?vue&type=template&id=7f16520a"
import script from "./LectureReview.vue?vue&type=script&lang=js"
export * from "./LectureReview.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__